import { connect } from 'react-redux';
import { compose } from 'redux';
import { Dispatch } from 'redux-api-middleware';
import { fetchAccount, updateAccount } from 'store/api/accounts/account/accountActions';
import { submitForm } from 'store/api/submitForm/submitForm';
import { AccountDetailsResponse, UpdateAccountPayload, UpdateAccountResponse } from 'store/api/types';

import { Account } from './Account';
import { AccountProps } from './Account.types';

const mapDispatchToProps = (dispatch: Dispatch, { match }: AccountProps) => ({
  onFetchAccount: () => dispatch<Promise<AccountDetailsResponse>>(fetchAccount(match.params.accountId)),
  onUpdateAccount: submitForm<UpdateAccountResponse>(dispatch, (body: UpdateAccountPayload) =>
    updateAccount(match.params.accountId, body),
  ),
});

export const AccountContainer = compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(Account);
